import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { isLoggedIn, isExpired } from '../../utils/auth-util';
import AuthorizationService from '../../service/AuthorizationService';
import CmsAPI from '../../../common/apis/CmsAPI';
import { useUserContext } from './../../context/UserContext';
import useProtectedPageMounted from './../../hooks/useProtectedPageMounted';

function PublicPage(props) {
  const { children } = props;

  const [isAuth, setIsAuth] = useState(false);
  const [expired, setExpired] = useState(true);
  const [loading, setIsLoading] = useState(true);
  const [lastSeen, setLastSeen] = useState(null);

  const { user, reloadUser } = useUserContext();

  useEffect(() => {
    if (!loading && !user) reloadUser();
  }, [loading]);

  useEffect(() => {
    const checkUser = async () => {
      const isUserLoggedIn = await isLoggedIn();
      setIsAuth(isUserLoggedIn);
      setExpired(isExpired());
      setIsLoading(false);
    };

    if (!isAuth || expired) {
      checkUser();
    } else {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    const updateUser = async () => {
      // We haven't logged last seen yet this session,
      // so do that now by pinging updateUser endpoint
      const userLanguage = window.navigator.userLanguage || window.navigator.language;
      const language = userLanguage ? userLanguage.slice(0, 2) : 'en';
      CmsAPI.updateUser({ language });

      setLastSeen(true);
    };

    // Log last seen
    if (isAuth && !loading && lastSeen === null) {
      updateUser();
    }
  }, [isAuth, loading]);

  return loading ? null : children;
}

export default PublicPage;
